import { Notification } from 'element-ui'

export default {
  data() {
    return {
      backendErrors: {},
    }
  },
  methods: {
    clearBackendErrors() {
      this.backendErrors = {}
    },
    processBackendErrors(e = {}) {
      const violations = e.violations || {}
      const length = Object.keys(violations).length

      if (length === 0 && e.message) {
        return Notification({
          type: 'error',
          title: 'Request error',
          message: e.message,
        })
      }

      const errors = {}

      for (const key in violations) {
        const value = violations[key]

        if (typeof value === 'string') {
          errors[key] = value
        } else if (value instanceof Array) {
          errors[key] = value[0]
        } else if (value.propertyPath) {
          errors[value.propertyPath] = value.message
        }
      }

      this.backendErrors = errors
    },
  },
}
